export default __webpack_public_path__ + "static/media/icon-transation-send.ff7b9ff9.svg";